/* Calendar-day estimates measured from the order date, with no extra cutoff day. */
(function () {
  'use strict';
  var DAY = 86400000;
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function formatRange(min, max, now) {
    now = now || new Date();
    var start = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
    var first = new Date(start + Number(min) * DAY);
    var last = new Date(start + Number(max) * DAY);
    var includeYear = first.getUTCFullYear() !== last.getUTCFullYear();
    // These labels have always used fixed en-GB/UTC, including the shortened Sep.
    // Avoid initializing the full Intl formatter on the product's first paint.
    function label(date) {
      if (!Number.isFinite(date.getTime())) throw new RangeError('Invalid time value');
      return date.getUTCDate() + ' ' + MONTHS[date.getUTCMonth()] + (includeYear ? ' ' + date.getUTCFullYear() : '');
    }
    if (first.getTime() === last.getTime()) return label(first);
    if (first.getUTCMonth() === last.getUTCMonth() && first.getUTCFullYear() === last.getUTCFullYear()) {
      return first.getUTCDate() + '–' + label(last);
    }
    return label(first) + ' – ' + label(last);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { formatRange: formatRange };
  if (typeof document === 'undefined') return;
  function refresh(scope) {
    var nodes = scope.matches && scope.matches('[data-kp-delivery-range]') ? [scope] : scope.querySelectorAll('[data-kp-delivery-range]');
    Array.prototype.forEach.call(nodes, function (node) {
      var min = Number(node.dataset.minDays), max = Number(node.dataset.maxDays);
      if (!Number.isFinite(min) || !Number.isFinite(max) || min < 0 || max < min) return;
      var text = formatRange(min, max);
      if (node.textContent !== text) node.textContent = text;
    });
  }
  function start() {
    refresh(document);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) { if (node.nodeType === 1) refresh(node); });
      });
    }).observe(document.body, { childList: true, subtree: true });
    function schedule() {
      var now = Date.now();
      var next = (Math.floor(now / DAY) + 1) * DAY;
      setTimeout(function () { refresh(document); schedule(); }, next - now + 100);
    }
    schedule();
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(document); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}());
